import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../Home/Home.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CharIcon from "../../Assets/img/word.png";
import Edit from "../../Assets/img/Edit.svg";
import Delet from "../../Assets/img/Delete.svg";
import defaultImg from "../../Assets/img/default-image.png";
import API from "../Service/Baseservice";
import Loading from "../../Loading/loading";
import TestimonialPreview from "./TestimonialPreview";
const testimonialIdMap = {
    1: 1, // English
    2: 2, // French
};

const homeIdMap = {
    1: 2, // English home
    2: 4, // French home
};

const getPlainTextLength = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent?.length || 0;
};

const TestimonialEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get("lang");
    const [deleteId, setDeleteId] = useState(null);
    const [languageId, setLanguageId] = useState(Number(langParam) || 1);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [heading, setHeading] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [deleteType, setDeleteType] = useState(null);
    const [showPreviewTestimonial, setShowPreviewTestimonial] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [videoTestimonials, setVideoTestimonials] = useState([]);
    const [videoReviews, setVideoReviews] = useState([]);
    const [listItems, setListItems] = useState([]);
    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    const [lastValidDescription, setLastValidDescription] = useState(description);
    // Fetch testimonial data

    const fetchTestimonial = () => {
        const mappedHomeId = homeIdMap[languageId];

        if (!mappedHomeId) return;

        setLoading(true);

        API.post("/testimoniallistview/condition", {
            language_id: languageId,
            home_id: mappedHomeId,
            testimonial_id: testimonialIdMap[languageId],
        })
            .then((response) => {
                const data = response.data.data;

                if (data.testimonials.length > 0) {
                    const t = data.testimonials[0];
                    setHeading(t.heading || "");
                    setTitle(t.title || "");
                    setDescription(t.description || "");
                    const filtered = (data.listitems || []).filter(
                        (item) => item.active !== 4
                    );
                    setListItems(filtered);
                }

                setVideoTestimonials(data.video_testimonials || []);
                setVideoReviews(data.video_reviews || []);
            })
            .catch((err) => console.error("API Error:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchTestimonial();
    }, [id, languageId]);


    // Handle update API call

    const handleUpdate = () => {
        if (!heading.trim()) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Heading is required!",
                type: "info",
            });
            return;
        }

        if (!title.trim()) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Title is required!",
                type: "info",
            });
            return;
        }

        if (!description.trim()) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Description is required!",
                type: "info",
            });
            return;
        }

        const mappedTestimonialId = testimonialIdMap[languageId];
        const mappedHomeId = homeIdMap[languageId];

        setLoading(true);

        const payload = {
            testimonial_id: mappedTestimonialId,
            language_id: languageId,
            home_id: mappedHomeId,
            heading,
            title,
            description,
            active: 1,
        };

        API.post("/testimonial_edit/update", payload)
            .then((res) => {
                if (res.data?.success === false) {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: res.data.message || "Failed to update testimonial.",
                        type: "error",
                    });
                    return;
                }

                setPopup({
                    show: true,
                    title: "Success",
                    message: "Testimonials updated successfully!",
                    type: "success",
                });
            })
            .catch(() => {
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to update testimonial.",
                    type: "error",
                });
            })
            .finally(() => setLoading(false));
    };



    const handleLanguageChange = (e) => {
        const newLang = Number(e.target.value);
        setLanguageId(newLang);


        const mappedTestimonialId = testimonialIdMap[newLang];
        navigate(`/testimonialedit/${mappedTestimonialId}?lang=${newLang}`);
    };
    const handleToggleStatusVideo = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        API.post("videotestimonial_status/update", {
            videotestimonial_id: id,
            status: newStatus,
        })
            .then(() => fetchTestimonial())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleToggleStatusReview = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        API.post("videoreview_status/update", {
            review_id: id,
            status: newStatus,
        })
            .then(() => fetchTestimonial())
            .catch((err) => console.error("Failed to update status:", err));
    };
    const handleConfirmDelete = () => {
        if (!deleteId || !deleteType) return;

        const apiUrl =
            deleteType === "video"
                ? "videotestimonial_delete/update"
                : "reviewtestimonial_delete/update";

        const payload =
            deleteType === "video"
                ? { videotestimonial_id: deleteId, active: 4 }
                : { review_id: deleteId, active: 4 };

        API.post(apiUrl, payload)
            .then(() => {
                fetchTestimonial();
                setShowPopup(false);
                setDeleteId(null);
                setDeleteType(null);
            })
            .catch((err) => console.error("Failed to delete:", err));
    };

    const confirmDeleteReview = () => {
        if (!deleteId) return;
        API.post("reviewtestimonial_delete/update", { review_id: deleteId, active: 4 })
            .then(() => {
                fetchTestimonial();
                setShowPopup(false);
                setDeleteId(null);
            })
            .catch((err) => console.error("Failed to delete news:", err));
    };
    const handleDeleteClickVideo = (id) => {
        setDeleteId(id);
        setDeleteType("video");
        setShowPopup(true);
    };

    const handleDeleteClickReview = (id) => {
        setDeleteId(id);
        setDeleteType("review");
        setShowPopup(true);
    };

    const handlePreview = () => {
        if (!heading.trim()) {
            alert("Heading is required for preview!");
            return;
        }

        if (!title.trim()) {
            alert("Title is required for preview!");
            return;
        }

        if (!description.trim()) {
            alert("Description is required for preview!");
            return;
        }

        setPreviewData({
            heading,
            title,
            description,
            videoTestimonials,
            videoReviews,
        });

        setShowPreviewTestimonial(true);
    };


    return (
        <div className="newss-containeradd">
            <div className="testimonial-header-bar">
                <h2 className="services-title1">Edit Testimonials</h2>
                <div className="header-right">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                className="input-field"
                                value={languageId}
                                onChange={handleLanguageChange}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleUpdate}>Save</button>
                    <button onClick={() => navigate("/homepage")} className="language-cancel-btn">Back</button>
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    {/* FORM SECTION */}
                    <div className="testimonial-containers">
                        <div className="form-group1">
                            <label>Heading<span className="required">*</span></label>
                            <input
                                type="text"
                                maxLength={70}
                                value={heading}
                                onChange={(e) => setHeading(e.target.value)}
                            />
                        </div>

                        <div className="form-group1">
                            <label>Title<span className="required">*</span></label>
                            <input
                                type="text"
                                maxLength={70}
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>

                        <div className="form-group ouradd-editor-small">
                            <label className="description-label">
                                <span className="label-text">
                                    Description <span className="required">*</span>
                                </span>
                                <div className="char-wrapper">
                                    <img src={CharIcon} alt="Character count" />
                                    <span className="char-count">
                                        {getPlainTextLength(description)}/4000
                                    </span>
                                </div>
                            </label>

                            <CKEditor
                                editor={ClassicEditor}
                                data={description}
                                onChange={(event, editor) => {
                                    const html = editor.getData();
                                    const div = document.createElement("div");
                                    div.innerHTML = html;
                                    const textLength = div.textContent?.length || 0;

                                    if (textLength <= 4000) {
                                        setLastValidDescription(html); 
                                        setDescription(html);
                                    } else {
                                        editor.setData(lastValidDescription);
                                    }
                                }}
                            />
                        </div>
                    </div>

                    {/* VIDEO TESTIMONIALS */}
                    <div>
                        <div className="testimonial-header-bar">
                            <h2>Edit Video Testimonials</h2>
                            <button
                                onClick={() =>
                                    navigate(`/testimonialvideoadd?lang=${languageId}&testimonial_id=${testimonialIdMap[languageId]}`)
                                }
                                className="saves-btn"
                            >
                                + Add Testimonial
                            </button>

                        </div>

                        <div className="newss-grid">
                            {videoTestimonials.length === 0 ? (
                                <p>No video testimonials found.</p>
                            ) : (
                                videoTestimonials.map((item) => (
                                    <div className="video-Testimonial-card" key={item.videotestimonial_id}>
                                        <div>
                                            {item.videos ? (
                                                <video className="testimonial-image" controls>
                                                    <source src={item.videos} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <img src={defaultImg} alt="No Video" className="testimonial-image" />
                                            )}

                                        </div>

                                        <p>{item.name}</p>

                                        <div className="category-card-footer1">
                                            <label className="category-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatusVideo(item.videotestimonial_id, item.status)
                                                    }
                                                />
                                                <span className="category-slider round">
                                                    <span className="category-switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>


                                            <div className="action-buttons1">
                                                <img
                                                    src={Edit}
                                                    alt="Edit"
                                                    onClick={() =>
                                                        navigate(`/testimonialvideoedit/${item.videotestimonial_id}`, {
                                                            state: { testimonialvideoedit: item },
                                                        })
                                                    }
                                                />
                                                <img src={Delet} alt="Delete" className="icon-btn1"
                                                    onClick={() => handleDeleteClickVideo(item.videotestimonial_id)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    {/* REVIEW TESTIMONIALS */}
                    <br />
                    <div>
                        <div className="testimonial-header-bar">
                            <h2>Review Testimonials</h2>

                            <button
                                onClick={() =>
                                    navigate(`/testimonialreviewadd?lang=${languageId}`, {
                                        state: { testimonial_id: testimonialIdMap[languageId] }
                                    })
                                }
                                className="saves-btn"
                            >
                                + Add Review Testimonial
                            </button>
                        </div>


                        <div className="newss-grid">
                            {videoReviews.length === 0 ? (
                                <p>No review testimonials found.</p>
                            ) : (
                                videoReviews.map((r) => (
                                    <div className="testimonial-card" key={r.review_id}>
                                        <div className="top-section">
                                            <div className="user-info">
                                                <img
                                                    src={r.imageupload || defaultImg}
                                                    alt="User"
                                                    className="user-img"
                                                />
                                                <div>
                                                    <h4 className="user-name">{r.name}</h4>
                                                    <p className="user-role">{r.professional}</p>
                                                </div>
                                            </div>

                                            <div className="rating">
                                                {"★".repeat(r.rating)}{"☆".repeat(5 - r.rating)}
                                            </div>
                                        </div>

                                        <p
                                            className="testimonial-text"
                                            dangerouslySetInnerHTML={{ __html: r.description }}
                                        ></p>

                                        <div className="category-card-footer1">
                                            <label className="review-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={r.status === "active"}
                                                    onChange={() =>
                                                        handleToggleStatusReview(r.review_id, r.status)
                                                    }
                                                />
                                                <span className="review-slider round">
                                                    <span className="review-switch-label">
                                                        {r.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>


                                            <div className="action-buttons1">
                                                <img
                                                    src={Edit}
                                                    alt="Edit"
                                                    onClick={() =>
                                                        navigate(`/testimonialreviewedit/${r.review_id}`, {
                                                            state: { testimonialreview: r },
                                                        })
                                                    }
                                                />
                                                <img src={Delet} alt="Delete" className="icon-btn1"
                                                    onClick={() => handleDeleteClickReview(r.review_id)} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </>
            )
            }
            {/* 🧩 Delete Confirmation Popup */}
            {
                showPopup && (
                    <div className="popup-overlay">
                        <div className="popup-box">
                            <h3>Confirm Delete</h3>
                            <p>Are you sure you want to delete this item?</p>

                            <div className="popup-buttons">
                                <button className="cancel-btn " onClick={() => setShowPopup(false)}>
                                    Cancel
                                </button>

                                <button className="btn delete-btn" onClick={handleConfirmDelete}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
            {showPreviewTestimonial && (
                <TestimonialPreview
                    previewService={previewData}
                    setShowPreviewTestimonial={setShowPreviewTestimonial}
                />
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                           <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/homepage");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default TestimonialEdit;
